import { render, staticRenderFns } from "./BotRequest.vue?vue&type=template&id=d7d37302&"
import script from "./BotRequest.vue?vue&type=script&lang=ts&"
export * from "./BotRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports